/** Product review moderation. Conventions: see `common.ts`. */
const reviews: Record<string, string> = {
  title: 'Reviews',
  in_view: '{total} in this view',
  loading: 'Loading reviews…',
  stars_label: '{rating} out of 5 stars',
  verified: 'Verified purchase',
  photo_alt: 'Customer photo {index}',
  has_reply: 'You replied',
  select_row: 'Select the review by {name}',

  'tabs.aria_label': 'Review status',
  'tabs.pending': 'Pending',
  'tabs.published': 'Published',
  'tabs.hidden': 'Hidden',

  'status.PENDING': 'Pending',
  'status.PUBLISHED': 'Published',
  'status.HIDDEN': 'Hidden',

  'filters.rating': 'Rating',
  'filters.any_rating': 'Any rating',
  'filters.stars': '{rating} stars',
  'filters.product': 'Product',
  'filters.any_product': 'Any product',

  'columns.product': 'Product',
  'columns.customer': 'Customer',
  'columns.review': 'Review',
  'columns.date': 'Date',
  'columns.status': 'Status',

  'actions.approve': 'Approve',
  'actions.hide': 'Hide',
  'actions.reply': 'Reply',

  'outcome.PENDING': 'Review moved back to pending.',
  'outcome.PUBLISHED': 'Review published.',
  'outcome.HIDDEN': 'Review hidden from your store.',
  'outcome.replied': 'Reply saved. It shows under the review on your store.',
  'outcome.reply_removed': 'Reply removed.',
  'outcome.deleted': 'Review deleted.',

  'bulk.approved': '{count} reviews published.',
  'bulk.hidden': '{count} reviews hidden.',

  'errors.update_failed': 'Could not update that review.',

  'plan.message': 'Product reviews are not included in your current plan.',
  'plan.see_plans': 'See plans',

  'settings.title': 'Review settings',
  'settings.auto_publish': 'Auto-publish new reviews',
  'settings.auto_publish_hint':
    'When off, new and edited reviews wait here for your approval before they appear on your store.',
  'settings.auto_on': 'New reviews will now be published straight away.',
  'settings.auto_off': 'New reviews will now wait for your approval.',

  search_label: 'Search reviews',
  search_placeholder: 'Review text, title or customer name…',

  'empty.search_title': 'Nothing matches that search',
  'empty.search_description': 'Try other words, another rating or another product.',
  'empty.title': 'No reviews here yet',
  'empty.description':
    'Reviews appear once signed-in customers rate your products. Add the "Product reviews" section to your product page so they can.',

  'delete.title': 'Delete this review?',
  'delete.message':
    'The review by {name} and any reply to it will be removed for good. Hiding it instead keeps it out of sight but lets you bring it back.',

  'detail.title': 'Review',
  'detail.your_reply': 'Your reply',
  'detail.reply_label': 'Your public reply',
  'detail.reply_hint': '{used} / {max} characters',
  'detail.replied_at': 'Replied on {date}',
  'detail.remove_reply': 'Remove reply',
  'detail.update_reply': 'Update reply',
  'detail.post_reply': 'Post reply',
};

export default reviews;
